module.exports = __webpack_public_path__ + "static/media/stanford_logo1.2c497738.png";